/* eslint-disable no-plusplus, jsx-a11y/anchor-has-content, array-callback-return, no-restricted-syntax, react/no-did-mount-set-state */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import canUseDOM from 'exenv';
import axios from 'axios';
import ResizeObserver from 'resize-observer-polyfill';

export default class RecircByTag extends Component {
  constructor(props) {
    super(props);

    this.determineIfMobile = this.determineIfMobile.bind(this);

    this.module = React.createRef();

    this.state = {
      articles: [],
      isMobile: true,
      moduleHeadline: 'More Like This',
      moduleHeadlineURL: '/'
    };
  }

  componentDidMount() {
    if (canUseDOM) {
      const mql = window.matchMedia('(max-width: 1023px)');
      mql.addListener(this.determineIfMobile);

      this.setState(
        {
          isMobile: window.innerWidth < 1024
        },
        () => {
          const ro = new ResizeObserver(entries => {
            for (const entry of entries) {
              const cr = entry.contentRect;

              this.module.current.closest('.social').style.marginBottom = this
                .state.isMobile
                ? '1.5625rem'
                : `${cr.height + 6 + 41}px`;
            }
          });

          if (canUseDOM && this.module && this.module.current) {
            ro.observe(this.module.current);
          }
        }
      );
    }

    if (this.props.post.recirc.config.useCustomRecirc === 'on') {
      switch (this.props.post.recirc.config.options.method) {
        case 'tag':
          axios(
            `//fc-api.fastcompany.com/api/v1/posts-tag-slugs/fastcompany/${
              this.props.post.recirc.config.options.params
            }`
          ).then(res => {
            this.autopilot(res.data);
          });

          break;

        default:
          break;
      }
    } else {
      axios(
        `//fc-api.fastcompany.com/api/v2/posts-category-slug/fastcompany/${
          this.props.post.categories[0].slug
        }`
      ).then(res => {
        this.autopilot(res.data);
      });
    }
  }

  autopilot(data) {
    const redirects = [
      {
        from: 'best-workplaces-for-innovators-2020',
        to: 'best-workplaces-for-innovators/2020'
      }
    ];

    let count = 0;
    let i = 0;
    const articles = [];

    while (count < 3) {
      if (data.posts[i].id !== this.props.post.id) {
        articles.push(data.posts[i]);
        count++;
      }

      i++;
    }

    if (articles.length > 0) {
      if (this.props.post.recirc.config.options.method === 'tag') {
        const redirectUrl = redirects.map(redirect => {
          // eslint-disable-next-line
          if (redirect.from === data.tags[0].slug) {
            return redirect.to;
          }
          return null;
        });

        this.setState({
          articles,
          moduleHeadlineURL: `/${
            redirectUrl ? redirectUrl[0] : data.tags[0].slug
          }`,
          moduleHeadline: `More From ${data.tags[0].name}`
        });
      } else {
        this.setState({
          articles,
          moduleHeadlineURL: `/${this.props.post.categories[0].slug}`
        });
      }
    }
  }

  determineIfMobile(e) {
    this.setState({
      isMobile: e.matches
    });
  }

  render() {
    if (this.state.isMobile) {
      return <aside className="article-recirc-by-tag" ref={this.module} />;
    }

    return (
      <aside className="article-recirc-by-tag" ref={this.module}>
        <div className="header">
          <div className="arrow">
            <img
              src="https://images.fastcompany.net/image/upload/v1595605760/fcweb/Path_33_zlkv0h.svg"
              alt=""
            />
          </div>

          <div className="package-name">{this.state.moduleHeadline}</div>

          <a
            href={`${
              this.state.moduleHeadlineURL
            }?icid=dan902:754:0:editRecirc`}
          />
        </div>

        <div className="articles">
          {this.state.articles &&
            this.state.articles.map((article, idx) => (
              <div className="article" key={`article-${idx}`}>
                <a
                  href={`${article.link}?icid=dan902:754:0:editRecirc`}
                  dangerouslySetInnerHTML={{
                    __html: article.title.rendered
                      ? article.title.rendered
                      : article.title
                  }}
                />
              </div>
            ))}
        </div>
      </aside>
    );
  }
}

RecircByTag.defaultProps = {
  post: {}
};

RecircByTag.propTypes = {
  post: PropTypes.shape({
    categories: PropTypes.shape([]),
    id: PropTypes.string,
    recirc: PropTypes.shape({
      config: PropTypes.shape({
        useCustomRecirc: PropTypes.string,
        options: PropTypes.shape({
          method: PropTypes.string,
          params: PropTypes.string
        })
      })
    })
  })
};
